/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export interface ServiceMetadata {}

export function Service(id: string, metadata: ServiceMetadata = {}): ClassDecorator {
	return (target) => {
		for (const property in metadata) {
			if (Object.prototype.hasOwnProperty.call(metadata, property)) {
				Reflect.defineMetadata(property, metadata[property], target);
			}
		}
	};
}
